import { useEffect, useState } from "react";
import { LoadingScreen } from "@/components/ui/loading-screen";

/**
 * Route-transition fallback that stays invisible for a short grace period.
 *
 * Most route chunks resolve in well under 200ms on a warm cache, and swapping
 * the whole app for a skeleton in that window is what read as "flickering"
 * between pages. Rendering nothing first keeps the previous paint on screen
 * (the browser has not repainted yet), and the skeleton only appears when the
 * wait is long enough to need feedback.
 */
export function DelayedFallback({ delayMs = 250 }: { delayMs?: number }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  if (!show) return null;
  return <LoadingScreen />;
}
